import React from 'react';
import clsx from 'clsx';
import getTicketPriceHeadline from '@dashboard/services/event/getTicketPriceHeadline';

const TicketTypeMultiSelectList = ({
  ticketTypes = [],
  selectedTicketTypes = new Map(),
  onToggle,
  interactive = true,
  currency = 'usd',
}) => {
  if (!ticketTypes || ticketTypes.length === 0) {
    return <div className="flex flex-col gap-y-1">This event has no tickets yet.</div>;
  }

  return (
    <div className="flex flex-col gap-y-1">
      {ticketTypes.map(ticketType => {
        const isSelected = selectedTicketTypes.has(ticketType._id);

        return (
          <div
            className={clsx(
              'p-2 w-full text-left flex justify-between rounded border transition-colors border-gray-200 dark:border-border',
              {
                'cursor-pointer hover:bg-gray-50 dark:hover:bg-muted': interactive,
                '!bg-muted !border-foreground': interactive && isSelected,
              },
            )}
            key={ticketType._id}
            onClick={interactive ? () => onToggle?.(ticketType) : undefined}
          >
            <div className="flex flex-row">
              <div className="flex flex-col mr-2">
                <div className="text-xs text-gray-400 dark:text-muted-foreground capitalize">
                  Ticket
                </div>
                <div className="text-sm font-semibold break-words">{ticketType?.name}</div>
                <div className="text-sm text-gray-700 dark:text-muted-foreground">
                  {ticketType?.capacity !== null ? `${ticketType.capacity} tickets` : 'Unlimited'}
                  {' • '}
                  {ticketType?.quantitySold || '0'} sold
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="text-sm">{getTicketPriceHeadline({ ticketType, currency })}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketTypeMultiSelectList;
